export default "__VITE_ASSET__DbTMmv2L__"